import React from 'react'

const Contact = (props) => {
    const formSubmit = (e) => { 
        e.preventDefault(); 
        const url = 'https://ardevia-site.azurewebsites.net/api/ContactRequestO365?code=E98bleC6zwTO6GwTDhMOgl/GZgGVi8CGcfpbaOWyxobbeGcjogMCZA==';
        const form = document.querySelector('#contact-form');
        fetch(
            url,
            { 
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST', 
                body: JSON.stringify({email: form.email.value, name: form.name.value, message: form.message.value })
            }
        )
            .then( (response) => { 
                if (response.ok) {
                    alert('Thanks for contacting us. We will reach back to you as soon as possible.');
                } else {
                    alert('An error occured on sending you\'re contact request. Please try again or send an email to info@ardevia.com');
                }
            }); 
    }
    return (
        <section id="contact">
            <div className="inner">
                <section>
                    <form id="contact-form" method="post" onSubmit={formSubmit}>
                        <div className="field half first">
                            <label htmlFor="name">Name</label>
                            <input type="text" name="name" id="name" />
                        </div>
                        <div className="field half">
                            <label htmlFor="email">Email</label>
                            <input type="text" name="email" id="email" />
                        </div>
                        <div className="field">
                            <label htmlFor="message">Message</label>
                            <textarea name="message" id="message" rows="6"></textarea>
                        </div>
                        <ul className="actions">
                            <li><input type="submit" value="Send Message" className="special" /></li>
                            <li><input type="reset" value="Clear" /></li>
                        </ul>
                    </form>
                </section>
                <section className="split">
                    <section>
                        <div className="contact-method">
                            <span className="icon alt fa-envelope"></span>
                            <h3>Email</h3>
                            <a href="mailto:info@ardevia.ch">info@ardevia.ch</a>
                        </div>
                    </section>
                    <section>
                        <div className="contact-method">
                            <span className="icon alt fa-phone"></span>
                            <h3>Phone</h3>
                            <span>+41 (44) 586 02 70</span>
                        </div>
                    </section>
                    <section>
                        <div className="contact-method">
                            <span className="icon alt fa-home"></span>
                            <h3>Address</h3>
                            <span>Burgstrasse 15<br />
                            8623 Wetzikon<br />
                            Switzerland</span>
                        </div>
                    </section>
                </section>
            </div>
        </section>
    );
};

export default Contact
